import { Grid, GridItem, Skeleton } from '@gusto/workbench';

export default function LoadingSkeleton() {
  return (
    <div aria-busy>
      <Grid templateColumns="max-content 1fr" columnGap={6} marginBottom={4}>
        <GridItem>
          <Skeleton height={36} marginBottom={4} width={225} />
        </GridItem>
      </Grid>
      <Grid autoRows="max-content" rowGap={4} marginBottom={8}>
        <Skeleton />
        <Skeleton width={2 / 3} />
      </Grid>
      <Skeleton height={300} borderRadius={4} />
    </div>
  );
}

export function LoadingSurveySkeleton() {
  return (
    <div aria-busy>
      <Grid autoRows="max-content" rowGap={4} marginBottom={8}>
        <Skeleton height={32} />
        <Skeleton width={1 / 3} />
      </Grid>
      <Skeleton height={300} borderRadius={4} marginBottom={8} />

      <Grid autoRows="max-content" rowGap={4} marginBottom={8}>
        <Skeleton height={32} />
        <Skeleton width={1 / 2} />
      </Grid>
      <Skeleton height={300} borderRadius={4} marginBottom={8} />

      <Grid autoRows="max-content" rowGap={4} marginBottom={8}>
        <Skeleton height={32} width={2 / 3} />
        <Skeleton />
      </Grid>
      <Skeleton height={450} borderRadius={4} marginBottom={8} />
    </div>
  );
}
